import { render, staticRenderFns } from "./selection.page.vue?vue&type=template&id=93948e3e&"
import script from "./selection.page.vue?vue&type=script&lang=js&"
export * from "./selection.page.vue?vue&type=script&lang=js&"
import style0 from "./selection.page.vue?vue&type=style&index=0&id=93948e3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports